import { useMembershipStatus } from '~/domains/plusMembership/hooks/useMembershipStatus';
import type { OAISchema } from '~/types/openapi';

import { MembershipTrialPrice } from './MembershipTrialPrice';
import { StandardWithBonuspackPrice } from './StandardWithBonuspackPrice';

type Props = {
  data: OAISchema['MarketProductDetailsResponseV2'];
};

export function ProductPriceInfo({ data }: Props) {
  const { isBonusPackRegistered } = useMembershipStatus();

  //  2. 멤버십 + 보너스팩 가입자만 노출
  if (isBonusPackRegistered) {
    return <StandardWithBonuspackPrice data={data} />;
  }

  return <MembershipTrialPrice data={data} />;

  // if (!nudgeData || data.price === data.totalDiscountedPrice) {
  //   return <NonDiscountPrice data={data} />;
  // }

  // // 3. 플멤 가입이 가능한 경우 + 플멤 할인가가 일반 쿠폰가보다 큰 경우
  // const isMembershipTrialPrice =
  //   isMembershipSubscribeServiceAvailable &&
  //   isMoreThan(data.totalDiscountedPrice, nudgeData?.details[0]?.nudgeAmount);

  // if (isMembershipTrialPrice) {
  //   return <MembershipTrialPrice data={data} />;
  // }

  // return (
  //   <>
  //     <DefaultProductPrice data={data} />

  //     {/* 할인 정보 */}
  //     {!!data.discountResult?.maximumDiscountAmount && (
  //       <DiscountBenefitCard data={data} />
  //     )}
  //     <ProductDetailMembersipNudge />
  //   </>
  // );
}
